import type { PositionAnalysisResponse } from "@patent-studio/api-types";
import { Panel } from "@/components/ui/Panel";

/**
 * The body of a row the run has not ruled: why it has no verdict, and, while
 * it is being assessed alone, that it is. A position with a verdict before it
 * was amended since the run; one without was added after it.
 */
export function NotAssessed({
  position,
  assessing,
  refusal = null,
}: {
  position: PositionAnalysisResponse;
  assessing: boolean;
  /** Why the server refused to assess it alone, in its own words, or nothing. */
  refusal?: string | null;
}) {
  const amended = position.previous_verdict !== null;
  return (
    <Panel
      shape="row"
      pad="tight"
      className="bg-muted/40 text-detail leading-relaxed"
    >
      <p>
        {amended
          ? "This position was amended since the analysis ran, so its verdict no longer applies."
          : "This position was added after the analysis ran."}{" "}
        It must be assessed to check it against the prior art library.
      </p>
      {assessing && (
        <p role="status" className="mt-1 font-semibold text-primary">
          Assessing this position against every readable document…
        </p>
      )}
      {refusal !== null && !assessing && (
        <p role="alert" className="mt-1 font-semibold text-destructive">
          It could not be assessed: {refusal}
        </p>
      )}
    </Panel>
  );
}
